export function textToBytes(text) {
  return new TextEncoder().encode(text);
}

export function bytesToBase64(bytes) {
  let binary = "";
  const chunkSize = 0x8000; // avoids stack overflow for large data

  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }

  return btoa(binary);
}

export function mergeBytes(chunks) {
  const totalLength = chunks.reduce((sum, c) => sum + c.length, 0);
  const result = new Uint8Array(totalLength);

  let offset = 0;
  for (const chunk of chunks) {
    result.set(chunk, offset);
    offset += chunk.length;
  }

  return result;
}

export const padToTwoSides = (left, right, width = 48) => {
  const spaceCount = width - left.length - right.length;
  const spaces = " ".repeat(spaceCount > 0 ? spaceCount : 1);
  return left + spaces + right + "\n";
};

export const pageCenter = (str, length = 48) => {
  const pad = Math.floor((length - str.length) / 2);
  return " ".repeat(pad > 0 ? pad : 0) + str;
};

export function formatLabel(status) {
  if (!status) return "-";
  return status
    .toLowerCase()
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function wordWrap(text, maxWidth) {
  const words = text.split(" ");
  const lines = [];
  let currentLine = "";

  for (const word of words) {
    const testLine = currentLine.length === 0 ? word : `${currentLine} ${word}`;
    if (testLine.length <= maxWidth) {
      currentLine = testLine;
    } else {
      if (currentLine.length > 0) {
        lines.push(currentLine);
      }
      currentLine = word;
    }
  }
  if (currentLine.length > 0) {
    lines.push(currentLine);
  }
  return lines;
}
